// ============================================
// 2. SuccessPage.jsx
// ============================================
import React from "react";
//import { useSearchParams } from "react-router-dom";
import { COLORS } from '../../utils/colors';
export default function BillingSuccess() {
  //const [searchParams] = useSearchParams();
  //const sessionId = searchParams.get("session_id");

  return (
    <div style={{
      textAlign: "center", 
      padding: "50px", 
      maxWidth: "600px", 
      margin: "0 auto"
    }}>
      <div style={{
        background: `${COLORS.secondary}15`,
        border: `2px solid ${COLORS.secondary}`,
        borderRadius: "10px",
        padding: "30px",
        marginBottom: "20px"
      }}>
        <h1 style={{color: COLORS.secondary, marginBottom: "20px"}}>
          🎉 Welcome to Your Free Trial!
        </h1>
        
        <p style={{fontSize: "18px", color: COLORS.secondary, marginBottom: "15px"}}>
          Your 14-day free trial has started successfully.
        </p>
        
        <p style={{color: COLORS.text, marginBottom: "20px"}}>
          You now have full access to all premium features for the next 14 days.
        </p>
      </div>

      <div style={{background: COLORS.background, padding: "20px", borderRadius: "8px", marginBottom: "20px"}}>
        <h3 style={{color: COLORS.text}}>What happens next?</h3>
        <ul style={{textAlign: "left", display: "inline-block", color: COLORS.textLight}}>
          <li>Explore all premium features for 14 days</li>
          <li>We'll send you a reminder 3 days before your trial ends</li>
          <li>No charges until your trial period ends</li>
          <li>Cancel anytime from your billing settings</li>
        </ul>
      </div>

      <div>
        <a 
          href="/dashboard" 
          style={{
            backgroundColor: COLORS.primary,
            color: "white",
            padding: "12px 24px",
            textDecoration: "none",
            borderRadius: "6px",
            marginRight: "10px",
            display: "inline-block"
          }}
        >
          Go to Dashboard
        </a>
        
        <a 
          href="/settings/billing"
          style={{
            backgroundColor: COLORS.secondary,
            color: "white",
            padding: "12px 24px",
            textDecoration: "none",
            borderRadius: "6px",
            display: "inline-block"
          }}
        >
          Billing Settings
        </a>
      </div>
    </div>
  );
}